module.exports = __webpack_public_path__ + "img/icons B_39.8f789ab5.svg";